import {
  buildReviewableCandidateShell,
  buildReviewableOrigin,
  REVIEWABLE_ORIGIN_COLLECTIONS,
  REVIEWABLE_ORIGIN_TYPES,
} from '../features/reviewableItems/reviewableItemFlow';

const normalizeText = (value = '') => String(value || '').trim();

export const BEHAVIOR_REVIEW_DOMAIN = 'behavior';
export const BEHAVIOR_REVIEW_ALLOWED_ACTIONS = ['save_timeline_event', 'ignore'];

export const buildBehaviorReviewCandidate = ({
  origin = {},
  extractedItem = {},
  confidence = '',
  suggestedAction = 'save_timeline_event',
} = {}) => {
  const description = normalizeText(
    extractedItem.description
    || extractedItem.title
    || extractedItem.label
    || extractedItem.sourceText
  );
  const sourceText = normalizeText(extractedItem.sourceText || origin.sourceText || description);
  const savedOrigin = buildReviewableOrigin({
    id: origin.id,
    type: origin.type || REVIEWABLE_ORIGIN_TYPES.TIMELINE_ENTRY,
    collection: origin.collection || REVIEWABLE_ORIGIN_COLLECTIONS.DAILY_LOGS,
    childId: origin.childId,
    sourceText,
    sourceSaved: origin.sourceSaved !== false,
    metadata: origin.metadata || {},
  });

  return {
    ...buildReviewableCandidateShell({
      origin: savedOrigin,
      domain: BEHAVIOR_REVIEW_DOMAIN,
      label: description || 'Behavior',
      sourceText,
      allowedActions: BEHAVIOR_REVIEW_ALLOWED_ACTIONS,
      suggestedAction,
      confidence,
      payload: {
        description,
        severity: extractedItem.severity,
        severityLabel: normalizeText(extractedItem.severityLabel),
        triggerNotes: normalizeText(extractedItem.triggerNotes || extractedItem.trigger),
        triggerSummary: normalizeText(extractedItem.triggerSummary || extractedItem.context),
        remedy: normalizeText(extractedItem.remedy || extractedItem.response),
        suspectedTriggers: Array.isArray(extractedItem.suspectedTriggers)
          ? extractedItem.suspectedTriggers
          : [],
        incidentDateTime: extractedItem.incidentDateTime || extractedItem.time || null,
        entryDateLabel: normalizeText(extractedItem.entryDateLabel),
        entryDayKey: normalizeText(extractedItem.entryDayKey),
      },
    }),
    extracted: {
      description,
      sourceText,
    },
  };
};
